import { Component, ViewChild, AfterViewInit } from '@angular/core';
import { MatSelect } from '@angular/material/select';
import { formatDate } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { ApiBusinessService } from 'src/app/services/api-business.service';
import { ApiSalesService } from 'src/app/services/api-sales.service';
import { BusinessService } from 'src/app/services/business.service';
import { PlacesService } from 'src/app/services/places.service';
import { ReportsService } from 'src/app/services/reports.service';
import { InfoCardComponent } from '../../shared/info-card/info-card.component';
import { fromEvent } from 'rxjs';

const MAX_SESSIONS_TO_DOWNLOAD = 30;

@Component({
  selector: 'app-reports-page',
  templateUrl: './reports-page.component.html',
  styleUrls: ['./reports-page.component.scss'],
})
export class ReportsPageComponent implements AfterViewInit {
  business!: any;
  loadedFilters: boolean = false;

  // Fechas
  datesRange!: any;
  stringDate: string = '';
  openDatePicker: boolean = false;
  dateFilter!: any;

  // Espacios
  openPlacesList: boolean = false;
  placesEnabled!: any;
  placeSelected: any = [];
  allPlaces: boolean = true;

  // Eventos
  openEventsList: boolean = false;
  eventsEnabled: any = [];
  eventsSelected!: any;
  allowEvents: boolean = false;
  groupedEvents: any = [];

  // Metodos
  methodsOptions!: any;
  methodSelected: any[] = [];
  allMethods: boolean = true;

  // Tipo de informe
  typeReport: any = 'global';
  formatReport: any = 'pdf';

  // Header Excel
  reportsGroupEnabled!: any;
  reportsGroupSelected: any[] = [];
  allColumns: boolean = false;

  // Eventos seleccionados
  openEventMultidate!: any;

  // Cargar informe
  loadingReport: boolean = false;
  selectGroup: any[] = [];
  matSelect: any;
  @ViewChild('listEvents') listEvents: MatSelect;
  page: number = 1;
  finishScroll: boolean = false;

  // Años y meses
  yearsMonths: any[] = [];
  monthsEvents: any[] = [];
  yearsMonthsLoaded: boolean = false;

  yearsMonthsData: any[] = [];
  EventSessionData: any[] = [];

  constructor(
    private apiBusiness: ApiBusinessService,
    private placeService: PlacesService,
    private businessService: BusinessService,
    private apiSalesService: ApiSalesService,
    private reportsService: ReportsService,
    private dialog: MatDialog,
  ) {}

  ngOnInit(): void {
    this.apiSalesService.getAllMethods().subscribe({
      next: (res) => {
        // Manejar respuesta que puede ser un objeto con data o un array
        this.methodsOptions = Array.isArray(res) ? res : res?.data || [];
        this.selectAllMethods();
      },
    });

    this.reportsService.getHeaderReports().subscribe({
      next: (res) => {
        // Manejar respuesta que puede ser un objeto con data o un array
        this.reportsGroupEnabled = Array.isArray(res) ? res : res?.data || [];
        if (Array.isArray(this.reportsGroupEnabled)) {
          this.reportsGroupSelected = this.reportsGroupEnabled.map(
            (value) => value.id,
          );
        }
      },
    });

    // Cargar datos iniciales
    // this.getData();
  }

  ngAfterViewInit() {
    this.apiBusiness.changed.subscribe({
      next: (value) => {
        if (value && value != 'place') {
          this.getData();
        }
      },
    });
  }

  getData() {
    this.business = JSON.parse(localStorage.getItem('business') || '{}');

    // Limpiamos los eventos seleccionados porque el espacio cambió
    this.selectGroup = [];
    this.EventSessionData = [];
    this.yearsMonthsData = [];

    this.placeService
      .getListFilterPlaces(this.business?.id, this.page, null, null, true)
      .subscribe({
        next: (res) => {
          const allPlaces = Array.isArray(res) ? res : res?.data?.data || res?.data || [];
          this.placesEnabled = this.placeService.filterManagedPlaces(allPlaces, this.business?.id);
          this.selectAllPlaces();
        },
      });

    // Obtenemos la fecha si existe y la formateamos
    let date_from = null;
    if (this.dateFilter && this.dateFilter.date_from) {
      date_from = this.dateFilter.date_from.replace(/\//g, '-');
    }
    let date_to = null;
    if (this.dateFilter && this.dateFilter.date_to) {
      date_to = this.dateFilter.date_to.replace(/\//g, '-');
    }

    // Obtenemos el espacio del local storage
    const spaceId = this.getSpacesLocalStorage();

    // Llamamos al servicio con TODOS los parámetros
    this.reportsService
      .getYearsMonths(this.business?.id, date_from, date_to, spaceId)
      .subscribe({
        next: (res) => {
          this.yearsMonths = res.data;
        },
      });
  }

  // Comparator para ordenar años de mayor a menor
  sortYearsDesc = (a: { key: string }, b: { key: string }) => {
    return Number(b.key) - Number(a.key);
  };

  // Comparator para ordenar meses de menor a mayor según el número
  sortMonthsAsc = (a: { key: string }, b: { key: string }) => {
    return Number(a.key) - Number(b.key);
  };

  selectPlaceFilter() {
    this.eventsSelected = null;
    this.loadedFilters = false;

    // Limpiamos selecciones
    this.selectGroup = [];
    this.EventSessionData = [];
    this.yearsMonthsData = [];

    // Recargamos los meses basados en el nuevo espacio interno
    let formattedDate = null;
    if (this.dateFilter && this.dateFilter.date_from) {
      formattedDate = this.dateFilter.date_from.replace(/\//g, '-');
    }
    let date_from = formattedDate;
    let date_to = null;
    if (this.dateFilter && this.dateFilter.date_to) {
      date_to = this.dateFilter.date_to.replace(/\//g, '-');
    }

    const spaceId = this.getEffectiveSpaceFilter();

    if (this.business?.id) {
      this.reportsService
        .getYearsMonths(this.business.id, date_from, date_to, spaceId)
        .subscribe({
          next: (res) => {
            this.yearsMonths = res.data;
          },
        });
    }
  }

  changeTypeReport() {
    if (this.typeReport == 'detail' && this.formatReport == 'pdf') {
      this.formatReport = 'csv';
      this.allColumns = true;
      this.selectAllColumns();
    }
  }

  // Manejar el cambio de selección
  onMethodSelectionChange(event: any) {
    // if (this.methodSelected.length != (this.methodsOptions.length + 1)) {
    //   this.allMethods = false;
    //   if (this.methodSelected.includes('all')) {
    //     let index = this.methodSelected.indexOf('all');
    //     this.methodSelected.splice(index, 1);
    //     this.methodSelected = [...this.methodSelected];
    //   }
    // } else {
    //   this.allMethods = true;
    //   this.selectAllMethods();
    // }
  }

  // Seleccionar todas las opciones
  selectAllMethods() {
    if (Array.isArray(this.methodsOptions)) {
      this.methodSelected = this.methodsOptions.map((option) => option.id);
    } else {
      this.methodSelected = [];
    }
  }

  selectAllPlaces() {
    if (Array.isArray(this.placesEnabled)) {
      this.placeSelected = this.placesEnabled.map((option) => option.id);
    } else {
      this.placeSelected = [];
    }
  }

  selectColumn(column, i) {
    let index = this.reportsGroupSelected.findIndex(
      (value) => value == column.id,
    );
    index == -1
      ? this.reportsGroupSelected.push(column.id)
      : this.reportsGroupSelected.splice(index, 1);
    const reportsLength = Array.isArray(this.reportsGroupEnabled)
      ? this.reportsGroupEnabled.length
      : 0;
    if (reportsLength != this.reportsGroupSelected.length) {
      this.allColumns = false;
    }
  }

  selectAllColumns() {
    if (this.allColumns && Array.isArray(this.reportsGroupEnabled)) {
      this.reportsGroupSelected = this.reportsGroupEnabled.map(
        (value) => value.id,
      );
      this.reportsGroupEnabled.forEach((element) => {
        element.selected = true;
      });
    }
  }

  getSpacesLocalStorage() {
    const places = localStorage.getItem('places');
    if (!places || places === 'null') return null;
    return places ? [JSON.parse(places)] : null;
  }

  // Devuelve el filtro de espacios efectivo según la selección actual del usuario:
  // - Si tiene todos los espacios seleccionados: usa el espacio del localStorage (restricción del usuario)
  // - Si tiene una selección parcial: usa los IDs seleccionados
  getEffectiveSpaceFilter(): any {
    const placesLength = Array.isArray(this.placesEnabled) ? this.placesEnabled.length : 0;
    return this.placeSelected?.length === placesLength
      ? this.getSpacesLocalStorage()
      : this.placeSelected;
  }

  getListEvents() {
    const placesLength = Array.isArray(this.placesEnabled)
      ? this.placesEnabled.length
      : 0;
    let venue =
      this.placeSelected?.length == placesLength
        ? this.getSpacesLocalStorage()
        : this.placeSelected;
    let fromDate = this.dateFilter
      ? this.formatStringDate(this.datesRange.min, 'yyyy-MM-dd')
      : null;
    let toDate = this.dateFilter
      ? this.formatStringDate(this.datesRange.max, 'yyyy-MM-dd')
      : null;
    this.businessService
      .getEventsReports(this.business?.id, this.page, venue, toDate, fromDate)
      .subscribe({
        next: (res) => {
          //checamos si ya no hay más datos para cargar
          if (this.page >= res.data.last_page) {
            this.finishScroll = true;
          }

          if (!this.finishScroll) {
            // Ordenados: primero el más nuevo

            // Manejar respuesta que puede ser un objeto con data o un array
            let events: any[] = [];
            if (Array.isArray(res)) {
              events = res;
            } else if (res?.data?.data && Array.isArray(res.data.data)) {
              // Estructura de paginación: res.data.data
              events = res.data.data;
            } else if (res?.data && Array.isArray(res.data)) {
              // Estructura simple: res.data
              events = res.data;
            } else if (res && typeof res === 'object') {
              // Si es un objeto pero no tiene data array, intentar encontrar un array anidado
              const findArray = (obj: any): any[] | null => {
                if (Array.isArray(obj)) return obj;
                if (obj && typeof obj === 'object') {
                  for (const key in obj) {
                    const result = findArray(obj[key]);
                    if (result) return result;
                  }
                }
                return null;
              };
              events = findArray(res) || [];
            }

            if (Array.isArray(events)) {
              events.forEach((event) => {
                // Manejar tanto event[0] como event directo
                const eventData = Array.isArray(event) ? event[0] : event;

                // Manejar tanto fechas/horarios como sessions
                let dates = eventData.sessions ? eventData.sessions : [];
                let hours = [];

                if (dates.length > 0) {
                  // Procesar fechas/sessions
                  dates.forEach((date) => {
                    const dateId = date.id;
                    const dateStart = date.fechaInicio || date.start_date;
                    const dateEnd = date.fechaFin || date.end_date;
                    const eventId = eventData.id;
                    const eventName = eventData.titulo || eventData.title;
                    const eventMultidate = eventData.multidate;
                    // Extraer la hora de la fecha de inicio de la sesión
                    const sessionTime =
                      date.horaInicio || date.start_time || dateStart;

                    if (hours && hours.length > 0) {
                      hours.forEach((hour) => {
                        this.eventsEnabled.push({
                          id: eventId,
                          multidate: eventMultidate,
                          name: eventName,
                          idDate: dateId,
                          date: dateStart,
                          idHour: hour.id,
                          hour: hour.horaInicio,
                        });
                      });
                    } else {
                      // Si no hay horarios, solo agregar la fecha/session
                      this.eventsEnabled.push({
                        id: eventId,
                        multidate: eventMultidate,
                        name: eventName,
                        idDate: dateId,
                        date: dateStart,
                        idHour: null,
                        hour: sessionTime,
                      });
                    }
                  });
                }
              });
              this.groupEventsByYearAndMonth();

              this.allowEvents = this.eventsEnabled.length;
              this.loadedFilters = true;
            }
          }
        },
      });
  }

  // Agrupar eventos por año
  groupEventsByYearAndMonth(): void {
    const eventsByYear = this.eventsEnabled.reduce((acc: any, event: any) => {
      const year = new Date(event.date).getFullYear();
      const month = new Date(event.date).toLocaleString('default', {
        month: 'long',
      });

      if (!acc[year]) {
        acc[year] = {};
      }
      if (!acc[year][month]) {
        acc[year][month] = { events: [], open: false }; // Inicialmente cerrado
      }
      acc[year][month].events.push(event);
      return acc;
    }, {});

    // Convertir a un formato adecuado para las opciones del desplegable y ordenar
    this.groupedEvents = Object.keys(eventsByYear)
      .sort((a, b) => Number(b) - Number(a)) // Ordenar años descendente
      .map((year) => ({
        year: Number(year),
        months: Object.keys(eventsByYear[year])
          .sort(
            (a, b) =>
              eventsByYear[year][b].monthNumber -
              eventsByYear[year][a].monthNumber,
          ) // Ordenar meses descendente
          .map((month) => ({
            month,
            events: eventsByYear[year][month].events.sort(
              (a: any, b: any) =>
                new Date(b.date).getTime() - new Date(a.date).getTime(),
            ), // Ordenar eventos descendente
            open: eventsByYear[year][month].open,
            selected: false, // Inicializar como no seleccionado
          })),
      }));
  }

  // Alternar visibilidad del mes
  toggleMonthVisibility(year: number, month: number, event: Event): void {
    event.stopPropagation(); // Evita interferir con el evento de apertura del selector
    this.loadMonthEvents(year, month, false);
    const yearGroup = this.yearsMonths.find((group) => group.year === year);
    if (yearGroup) {
      const monthGroup = yearGroup.months.find((m) => m.code === month);
      if (monthGroup) {
        monthGroup.open = !monthGroup.open; // Alternar estado
      }
    }
  }

  selectEventSession(
    eventId: number,
    sessionId: number,
    year: number,
    month: number,
  ) {
    const indexYearMonth = this.yearsMonthsData.findIndex(
      (item) => item.year === year && item.month === month,
    );

    if (indexYearMonth != -1) {
      this.yearsMonthsData.splice(indexYearMonth, 1);
      this.selectGroup = this.selectGroup.filter(
        (item) => !(item.isMonth && item.year === year && item.month === month),
      );

      const monthGroup = this.yearsMonths
        .find((y) => y.year === year)
        ?.months.find((m) => m.code === month);
      monthGroup?.allSessionsOrdered.forEach((session) => {
        if (session.id !== sessionId) {
          this.EventSessionData.push({
            event: session.id_event,
            session: session.id,
          });
        } else {
          this.selectGroup = this.selectGroup.filter(
            (item) => item.id !== sessionId,
          );
        }
      });
    } else {
      const indexEventSession = this.EventSessionData.findIndex(
        (item) => item.event === eventId && item.session === sessionId,
      );

      if (indexEventSession != -1) {
        this.EventSessionData.splice(indexEventSession, 1);
        this.selectGroup = this.selectGroup.filter(
          (item) => item.id !== sessionId,
        );
      } else {
        this.EventSessionData.push({ event: eventId, session: sessionId });
      }
    }

    this.selectGroup = [...this.selectGroup];
  }

  loadMonthEvents(year: number, month: number, select: boolean): void {
    let monthGroup = this.yearsMonths
      .find((yg) => yg.year === year)
      ?.months.find((mg) => mg.code === month);

    const spaceId = this.getEffectiveSpaceFilter();

    if (!(monthGroup && monthGroup.events && monthGroup.events.length > 0)) {
      this.businessService
        .getEventsReports(
          this.business?.id,
          1,
          spaceId,
          this.formatStringDate(this.datesRange?.max, 'yyyy-MM-dd') ?? null,
          this.formatStringDate(this.datesRange?.min, 'yyyy-MM-dd') ?? null,
          year,
          month,
        )
        .subscribe({
          next: (res) => {
            let rawEvents = res.data;
            if (Array.isArray(rawEvents)) {
              let allSessionsFlat: any[] = [];
              rawEvents.forEach((event) => {
                if (event.sessions) {
                  event.sessions.forEach((session) => {
                    allSessionsFlat.push({
                      ...session,
                      eventTitle: event.title,
                      eventMultidate: event.multidate,
                      id_event: event.id,
                    });
                  });
                }
              });

              allSessionsFlat.sort(
                (a, b) =>
                  new Date(a.start_date).getTime() -
                  new Date(b.start_date).getTime(),
              );

              monthGroup.allSessionsOrdered = allSessionsFlat;
              monthGroup.events = rawEvents;

              // --- NUEVA LÓGICA DE MARCADO POST-CARGA ---
              // Verificamos si este mes ya debería estar seleccionado
              const isMonthSelected = this.yearsMonthsData.some(
                (item) => item.year === year && item.month === month,
              );

              if (isMonthSelected && monthGroup.allSessionsOrdered) {
                monthGroup.allSessionsOrdered.forEach((session) => {
                  const alreadyInVisual = this.selectGroup.some(
                    (item) => item.id === session.id,
                  );
                  if (!alreadyInVisual) {
                    this.selectGroup.push(session);
                  }
                });
                this.selectGroup = [...this.selectGroup]; // Refrescar UI
              }
            }
          },
        });
    }
  }

  selectAllMonthEvents(year: number, month: number, select: boolean): void {
    const indexYearMonth = this.yearsMonthsData.findIndex(
      (item) => item.year === year && item.month === month,
    );
    const monthGroup = this.yearsMonths
      .find((yg) => yg.year === year)
      ?.months.find((mg) => mg.code === month);

    if (indexYearMonth != -1) {
      this.yearsMonthsData.splice(indexYearMonth, 1);
      this.selectGroup = this.selectGroup.filter(
        (item) => !(item.isMonth && item.year === year && item.month === month),
      );

      if (monthGroup && monthGroup.allSessionsOrdered) {
        monthGroup.allSessionsOrdered.forEach((session) => {
          this.EventSessionData = this.EventSessionData.filter(
            (item) => item.session !== session.id,
          );
          this.selectGroup = this.selectGroup.filter(
            (item) => item.id !== session.id,
          );
        });
      }
    } else {
      this.yearsMonthsData.push({ year: year, month: month });
      // Aquí el objeto {isMonth: true...} ya fue agregado por el mat-select.

      if (monthGroup && monthGroup.allSessionsOrdered) {
        monthGroup.allSessionsOrdered.forEach((session) => {
          // Solo agregamos a selectGroup si NO está ya (evita duplicados)
          if (!this.selectGroup.some((item) => item.id === session.id)) {
            this.selectGroup.push(session);
          }
          this.EventSessionData = this.EventSessionData.filter(
            (item) => item.session !== session.id,
          );
        });
      }
    }

    this.loadMonthEvents(year, month, select);
    this.selectGroup = [...this.selectGroup];
  }

  getEventsFromSelectedMonths(yearGroup, monthsSelection): any[] {
    return yearGroup.months
      .filter((m) =>
        monthsSelection.some(
          (selMonth) => selMonth.isMonth && selMonth.month === m.month,
        ),
      )
      .flatMap((m) => m.events);
  }

  updateMonthSelection(year: number, month: string): void {
    const yearGroup = this.groupedEvents.find((group) => group.year === year);
    if (yearGroup) {
      const monthGroup = yearGroup.months.find((m) => m.month === month);
      if (monthGroup) {
        // Actualizar si el mes está completamente seleccionado o no
        monthGroup.selected = monthGroup.events.every((event) =>
          this.selectGroup.some(
            (selectedEvent) => selectedEvent?.id === event?.id,
          ),
        );
      }
    }
  }

  isMonthSelected(year: number, month: string): boolean {
    const yearGroup = this.groupedEvents.find((group) => group.year === year);
    if (yearGroup) {
      const monthGroup = yearGroup.months.find((m) => m.month === month);
      if (monthGroup) {
        return monthGroup.events.every((event) =>
          this.selectGroup.some(
            (selectedItem) =>
              selectedItem?.id === event?.id &&
              selectedItem?.date === event?.date &&
              selectedItem?.hour === event?.hour,
          ),
        );
      }
    }
    return false;
  }

  compareEvents(event1: any, event2: any): boolean {
    if (event1?.isMonth && event2?.isMonth) {
      return event1.year === event2.year && event1.month === event2.month;
    }
    return (
      event1?.id === event2?.id &&
      event1?.date === event2?.date &&
      event1?.hour === event2?.hour
    );
  }

  changeEventsSelected(): void {
    this.selectGroup = [...this.selectGroup];
  }

  removeEventSelected(index: any) {
    this.eventsSelected.splice(index, 1);
    this.eventsSelected = [...this.eventsSelected];
  }

  openMultidate(event: any) {
    this.openEventMultidate = this.openEventMultidate ? null : event.id;
  }

  selectDates(datesRange: any) {
    this.datesRange = datesRange;
    let stringDates = this.formatStringDate(datesRange.min);

    if (datesRange.max) {
      stringDates += ' - ' + this.formatStringDate(datesRange.max);
    }

    this.stringDate = stringDates;

    this.dateFilter = {
      date_from: this.formatStringDate(datesRange.min, 'dd/MM/yyyy'),
      date_to: this.formatStringDate(datesRange.max, 'dd/MM/yyyy'),
    };

    if (datesRange.min && this.business?.id) {
      const date_from = this.dateFilter.date_from.replace(/\//g, '-');
      const date_to = this.dateFilter.date_to.replace(/\//g, '-');
      const spaceId = this.getEffectiveSpaceFilter();

      // Enviamos ID negocio, fecha y espacio
      this.reportsService
        .getYearsMonths(this.business.id, date_from, date_to, spaceId)
        .subscribe({
          next: (res) => {
            this.yearsMonths = res.data;
          },
          error: (err) => console.error('Error al actualizar fechas:', err),
        });
    }
  }

  formatStringDate(date: any, format: string = 'dd MMM yy') {
    let dateFormat = null;
    if (date) {
      dateFormat = formatDate(new Date(date), format, 'es', '+0000');
    }
    return dateFormat;
  }

  clearRangeDates(event: any) {
    if (event) {
      event.stopPropagation(); // Evita que el click se propague al div
    }
    this.datesRange = null;
    this.stringDate = '';
    this.dateFilter = null;
    this.openDatePicker = false;
    //this.getListEvents();
    this.getData(); // Refrescamos todos los filtros al limpiar fechas, ya que pueden afectar a eventos disponibles en otros selects
  }

  // Descargar informe
  downloadPDF() {
    const selectedSessionsForCount = this.selectGroup.filter(
      (item) => item && !item.isMonth && !item.isSelectAll,
    );
    const totalSessions = selectedSessionsForCount.length;

    if (totalSessions >= MAX_SESSIONS_TO_DOWNLOAD) {
      this.dialog.open(InfoCardComponent, {
        panelClass: ['info-dialog'],
        data: {
          icon: true,
          text: `No se pueden descargar ${totalSessions} elementos a la vez, por favor, prueba a descargar informes mensuales o seleccionar un máximo de ${MAX_SESSIONS_TO_DOWNLOAD} eventos o sesiones para completar la descarga.`,
          btnCancel: false,
        },
      });
      return;
    }

    this.loadingReport = true;
    const methodsLength = Array.isArray(this.methodsOptions)
      ? this.methodsOptions.length
      : 0;
    const reportsLength = Array.isArray(this.reportsGroupEnabled)
      ? this.reportsGroupEnabled.length
      : 0;
    const methods =
      this.methodSelected?.length != methodsLength ? this.methodSelected : null;
    const reports =
      this.reportsGroupSelected?.length != reportsLength
        ? this.reportsGroupSelected
        : null;
    const selectedSessions = this.selectGroup.filter(
      (item) => item && !item.isMonth && !item.isSelectAll,
    );

    // Construir array de eventos con sus sesiones: [{id: eventId, sessions: [sessionId1, sessionId2]}]
    const eventsMap = new Map<number, number[]>();

    this.EventSessionData.forEach((item) => {
      if (!eventsMap.has(item.event)) {
        eventsMap.set(item.event, []);
      }
      if (!eventsMap.get(item.event)!.includes(item.session)) {
        eventsMap.get(item.event)!.push(item.session);
      }
    });

    const events = Array.from(eventsMap.entries()).map(([id, sessions]) => ({
      id,
      sessions,
    }));

    //console.log('Eventos con sesiones:', events);

    // Construimos un array con los años y meses seleccionados [{year: 2025, months: [1, 2, 3]}]
    const yearsMap = new Map<number, number[]>();

    this.yearsMonthsData.forEach((item) => {
      if (!yearsMap.has(item.year)) {
        yearsMap.set(item.year, []);
      }
      if (!yearsMap.get(item.year)!.includes(item.month)) {
        yearsMap.get(item.year)!.push(item.month);
      }
    });

    const years = Array.from(yearsMap.entries()).map(([year, months]) => ({
      year,
      months,
    }));

    const payload = {
      events: events,
      dates: this.dateFilter,
      format: this.formatReport,
      type: this.typeReport,
      method: methods,
      reportsgroup: reports,
      years: years,
    };
    this.reportsService
      .downloadReportFile(this.business?.id, payload)
      .subscribe({
        next: (res) => {
          if (res) {
            const linkSource = res;
            const type =
              this.formatReport == 'csv' ? 'text/csv' : 'application/pdf';
            const windowOpen = this.formatReport == 'csv' ? '_self' : '_blank';
            const base64WithMime = `data:${type};base64,${linkSource}`;

            const newTab = window.open('', '_blank');
            if (newTab) {
              newTab.document.body.innerHTML = `
              <iframe src="${base64WithMime}" frameborder="0" style="border:0; width:100%; height:100%;" allowfullscreen></iframe>
            `;
              newTab.document.title = 'Informe';
            }
          }
          this.loadingReport = false;
        },
        error: (err) => {
          let msg =
            '¡Vaya! Algo ha salido mal, no se ha podido descargar el informe.';
          if (err.error.events && err.error.events?.length > 0) {
            msg =
              'Lo sentimos, los siguientes eventos no tienen disponible el informe detalle: ';
            err.error.events.forEach((element, key) => {
              msg += element;
              if (key != err.error.events.length - 1) msg += ', ';
            });
          }
          const dialogRef = this.dialog.open(InfoCardComponent, {
            panelClass: ['info-dialog'],
            data: {
              icon: true,
              text: msg,
              btnCancel: false,
            },
          });
          this.loadingReport = false;
        },
      });
  }

  clearFilters() {
    this.clearRangeDates(null);
    this.placeSelected = null;
    this.eventsSelected = null;
    this.selectAllMethods();
    this.selectAllPlaces();
  }

  // En reports-page.component.ts

  getMonthNameByCode(code: number): string {
    const monthNames = [
      'enero',
      'febrero',
      'marzo',
      'abril',
      'mayo',
      'junio',
      'julio',
      'agosto',
      'septiembre',
      'octubre',
      'noviembre',
      'diciembre',
    ];
    return monthNames[code - 1] || '';
  }
}

function base64ToUint8Array(base64: string): Uint8Array {
  const binaryString = window.atob(base64); // Puedes mantener atob por ahora ya que sigue siendo funcional en navegadores
  const len = binaryString.length;
  const bytes = new Uint8Array(len);

  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes;
}
